import React, { useState } from 'react';
import { Box, Button, MobileStepper } from '@mui/material';
import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';

const images = [
  '/gallary/laundromatPicture.JPG',
  '/gallary/GallaryPicture1.JPG',
  '/gallary/GallaryPicture2.JPG',
  '/gallary/GallaryPicture3.JPG',
  '/gallary/GallaryPicture4.JPG',
  '/gallary/GallaryPicture5.JPG',
  '/gallary/GallaryPicture6.JPG',
  '/gallary/GallaryPicture7.JPG',
  '/gallary/GallaryPicture8.JPG',
];

const Gallery: React.FC = () => {
  const [activeStep, setActiveStep] = useState(0);
  const maxSteps = images.length;

  const handleNext = () => {
    setActiveStep((prevActiveStep) => (prevActiveStep + 1) % maxSteps);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => (prevActiveStep - 1 + maxSteps) % maxSteps);
  };

  return (
    <Box sx={{ textAlign: 'center', backgroundColor: 'background.default'}}>
      <Box
        sx={{
          maxWidth: '80%',
          height: 'auto', // Fixed height for the gallery container
          margin: '0 auto',
          position: 'relative',
        }}
      >
        <Box
          component="img"
          src={images[activeStep]}
          alt={`Gallery Image ${activeStep + 1}`}
          sx={{
            width: '100%',
            height: 500,
            objectFit: 'contain',
            borderRadius: 2,
            boxShadow: 3,
            padding: 2
          }}
        />
        <MobileStepper
          steps={maxSteps}
          position="static"
          activeStep={activeStep}
          sx={{ mt: 2 }}
          nextButton={
            <Button size="small" onClick={handleNext}>
              Next
              <KeyboardArrowRight />
            </Button>
          }
          backButton={
            <Button size="small" onClick={handleBack}>
              <KeyboardArrowLeft />
              Back
            </Button>
          }
        />
      </Box>
    </Box>
  );
};

export default Gallery;